import { render, staticRenderFns } from "./security-monitoring.vue?vue&type=template&id=797367d0&scoped=true"
import script from "./security-monitoring.vue?vue&type=script&lang=js"
export * from "./security-monitoring.vue?vue&type=script&lang=js"
import style0 from "./security-monitoring.vue?vue&type=style&index=0&id=797367d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797367d0",
  null
  
)

export default component.exports